import { render, staticRenderFns } from "./user-rights-table.vue?vue&type=template&id=4ec2a1e1&scoped=true&"
import script from "./user-rights-table.vue?vue&type=script&lang=ts&"
export * from "./user-rights-table.vue?vue&type=script&lang=ts&"
import style0 from "./user-rights-table.vue?vue&type=style&index=0&id=4ec2a1e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec2a1e1",
  null
  
)

export default component.exports